import $ from 'jquery';

$('.footer__button').click(function() {
  $('html, body').animate({scrollTop:0}, '300');
})
